import React, { useState } from "react";

export default function EmailLocator() {
  const [email, setEmail] = useState("");
  const [ips, setIps] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  const allCountries = [
    "Japan",
    "Canada",
    "Brazil",
    "Australia",
    "United States",
    "United Kingdom",
    "Sweden",
    "Norway",
    "South Africa",
    "India",
    "Mexico",
    "Argentina",
    "New Zealand",
    "Chile",
    "South Korea",
  ]; // nema Srbije/Balkana

  const generateRandomIp = () => {
    const part = () => Math.floor(Math.random() * 256);
    return `${part()}.${part()}.${part()}.${part()}`;
  };

  const handleSearch = () => {
    // 5–6 random IP adresa
    const count = Math.floor(Math.random() * 2) + 5; // 5 ili 6
    const newIps = Array.from({ length: count }, generateRandomIp);
    setIps(newIps);
    setCountries([]);
    setLoading(false);
  };

  const handleLocate = () => {
    if (!ips.length) return;

    setLoading(true);
    setCountries([]);

    setTimeout(() => {
      // 5 random država, bez ponavljanja
      const shuffled = [...allCountries].sort(() => Math.random() - 0.5);
      setCountries(shuffled.slice(0, 5));
      setLoading(false);
    }, 10000); // 10 sekundi
  };

  return (
    <div className="loc-page">
      <div className="loc-header">
        <span className="loc-logo-square" />
        <span className="loc-logo-text">VPN Tracker</span>
      </div>

      <div className="loc-main">
        {/* Leva kartica */}
        <div className="loc-card loc-left">
          <h2 className="loc-title">Proveri email</h2>
          <p className="loc-subtitle">
            Unesi email adresu i klikni na <strong>Pretraži</strong>.
          </p>

          <div className="loc-form">
            <input
              type="email"
              placeholder="email@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="loc-input"
            />
            <button className="loc-btn-primary" onClick={handleSearch}>
              Pretraži
            </button>
          </div>

          {ips.length > 0 && (
            <>
              <h3 className="loc-section-title">Moguće IP adrese</h3>
              <ul className="loc-ip-list">
                {ips.map((ip, idx) => (
                  <li key={idx} className="loc-ip-item">
                    {ip}
                  </li>
                ))}
              </ul>

              <button className="loc-btn-secondary" onClick={handleLocate}>
                Lociraj
              </button>
            </>
          )}
        </div>

        {/* Desna kartica */}
        <div className="loc-card loc-right">
          {!ips.length && !loading && countries.length === 0 && (
            <p className="loc-placeholder">
              Unesi email adresu sa leve strane i klikni{" "}
              <strong>Pretraži</strong>. Nakon toga možeš da pokreneš{" "}
              <strong>Lociraj</strong> da vidiš random države.
            </p>
          )}

          {loading && (
            <div className="loc-loader-wrap">
              <div className="loc-loader" />
              <p>Lociranje IP adresa širom sveta...</p>
            </div>
          )}

          {!loading && countries.length > 0 && (
            <div>
              <h3 className="loc-section-title">Moguće lokacije</h3>
              <ul className="loc-country-list">
                {countries.map((country, idx) => (
                  <li key={idx} className="loc-country-item">
                    {country}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
